import { render, staticRenderFns } from "./JbListStudent.vue?vue&type=template&id=83531858&"
import script from "./JbListStudent.vue?vue&type=script&lang=js&"
export * from "./JbListStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports